import { IAdminTutorialContent } from '@/store/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface ItutorialContentListState {
  loading: boolean;
  list: IAdminTutorialContent[];
  filter: {
    input: string,
    option: 'email'|'name'|'title'|'description',
    categoryType: number,
    levelType: number,
  }
}

const tutorialContentListSlice = createSliceSteamup(
  'tutorialContentList',
  {
    loading: true,
    list: [],
    filter: {
      input: '',
      option: 'email',
      categoryType: 0,
      levelType: 0,
    },
  } as ItutorialContentListState,
  {
    setList(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    // 공개/비공개 만들기
    setListOnOffChange(state, { payload }: PayloadAction<({onOff: boolean, listIndex: number})>) {
      const { onOff, listIndex } = payload;
      state.list[listIndex].isReadable = onOff;
    },
    setKeyword(state, { payload }: PayloadAction<(typeof state.filter.input)>) {
      state.filter.input = payload;
    },
    setOption(state, { payload }: PayloadAction<(typeof state.filter.option)>) {
      state.filter.option = payload;
    },
    setCategoryType(state, { payload }: PayloadAction<(typeof state.filter.categoryType)>) {
      state.filter.categoryType = payload;
    },
    setLevelType(state, { payload }: PayloadAction<(typeof state.filter.levelType)>) {
      state.filter.levelType = payload;
    },
  },
);

export default tutorialContentListSlice;
